export default "__VITE_ASSET__D7b44qoP__"